<template>
	<div>

		<v-card-title>{{ opción.nombre }}</v-card-title>
		<v-card-text>
			<p>{{ opción.descripción }}</p>
		</v-card-text>

		<v-divider></v-divider>

		<div v-for="(s, i) in opción.secciones" :key="`s${i}`" class="px-4 py-1">

			<h5 class="title" style="font-weight: 300;">{{ s.título }}</h5>

			<div v-for="(c, j) in s.componentes" :key="`c${j}`" class="pl-4 py-3">

				<div v-if="c.selección">

					<h6 class="subtitle-1"><tt>●&nbsp;</tt>{{ c.nombre }}</h6>

					<p class="my-0 body-2 font-weight-light"><tt>&nbsp;&nbsp;</tt>{{ c.descripción }}</p>

					<div v-for="(p, k) in c.personalizaciones" :key="`p${k}`" class="pl-6">

						<div v-if="p.tipo === 'SELECCIÓN_SIMPLE'" class="py-2">
							<div
								:class="{ 'opcion-desmarcada': !p.configuración.selección }"
								style="white-space: nowrap; overflow: hidden; "
							>
								<v-icon dense v-if="p.configuración.selección" color="green">mdi-checkbox-marked</v-icon>
								<v-icon dense v-else color="grey">mdi-checkbox-blank-outline</v-icon>
								<span>{{ p.configuración.descripción }}</span>
							</div>
						</div>

						<div v-if="p.tipo === 'OPCIONES_MÚLTIPLES'" class="py-2">
							<p class="mt-0 mb-2" v-if="p.configuración.descripción">{{ p.configuración.descripción }}</p>
							<div 
								v-for="(o, l) in p.configuración.opciones" 
								:key="`o${l}`"
								:class="{ 'opcion-desmarcada': p.configuración.selección !== l }"
								style="white-space: nowrap; overflow: hidden; "
							>
								<v-icon dense v-if="p.configuración.selección === l" color="green">mdi-radiobox-marked</v-icon>
								<v-icon dense v-else color="grey">mdi-radiobox-blank</v-icon>
								<span>{{ o.descripción }}</span>
							</div>
						</div>

						<v-divider v-if="k+1 < c.personalizaciones.length"></v-divider>

					</div>

				</div>

				<div v-else>
					<h6 style="text-decoration: line-through solid silver;" class="subtitle-2"><tt>●</tt> {{ c.nombre }}</h6>
					<p style="text-decoration: line-through solid silver;" class="mt-0 mb-2 body-2 font-weight-light"><tt>&nbsp;</tt> {{ c.descripción }}</p>
				</div>

				<v-divider v-if="j+1 < s.componentes.length" style="border-color: silver"></v-divider>

			</div>

			<v-divider v-if="i+1 < opción.secciones.length" style="border-color: grey"></v-divider>

		</div>
	</div>
</template>

<script>
export default {
	name: 'OpcionResumen',
	data: () => ({
		//
	}),
	props: ['opción'],
}
</script>

<style scoped>
	.opcion-desmarcada {
		color: silver;
		font-size: 90%;
		text-decoration: line-through solid silver;
	}
</style>